import React, {PureComponent} from 'react';
import Modal from 'react-responsive-modal';

import CustomerProduct from '../../components/customersuccessportal/CustomerProduct';
import CustomerProductAdd from '../../components/customersuccessportal/CustomerProductAdd';

import { RESPONSE_STATUS } from '../../utils/constants';

import Api from '../../utils/api';
import HttpUtils from '../../utils/http';

class CustomerProductRow extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            isEditing: false,
            recommendedProducts: this.props.recommendedProducts,
            additionalRecos: [],
            showAdditionalRecos: false,
            currentRecoId: 0,
            currentRecoScore: 0,
            expandedRecoId: 0,
            expandedRecoScore: 0,
            prodIdInput: '',
            prodScoreInput: '',
            addInputId: '',
            addInputScore: '',
            showDeleteModal: false
        };

        this.toggleEditing = this.toggleEditing.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
        this.getExpandedRecommendations = this.getExpandedRecommendations.bind(this);
        this.renderExpandedRecos = this.renderExpandedRecos.bind(this);
        this.replaceProductArray = this.replaceProductArray.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.generateProductArray = this.generateProductArray.bind(this);
        this.handleProductInputChange = this.handleProductInputChange.bind(this);
        this.getScoreOfInputProduct = this.getScoreOfInputProduct.bind(this);
        this.handleAddProductInputChange = this.handleAddProductInputChange.bind(this);
        this.handleAddProductInputChangeScore = this.handleAddProductInputChangeScore.bind(this);
        this.addToProductArray = this.addToProductArray.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
        this.fun_submitDataServer = this.fun_submitDataServer.bind(this);
        this.renderProductFeed = this.renderProductFeed.bind(this);

        this.productRowIds = [];
    }

    componentDidMount() {
        this.generateProductArray();
    }

    toggleEditing(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isEditing: !this.state.isEditing });
    }

    generateProductArray() {
        let recommendedProducts = this.state.recommendedProducts;
        recommendedProducts
        .filter((product) => { return product.type === this.props.type })
        .forEach((product, index, arr) => {
            let productRowIdString = product.id + ":" + product.score;
                this.productRowIds.push(productRowIdString);
        })
        let prodRowIdsSort = this.productRowIds.sort((prodOne, prodTwo) => {
            let prodOneScore = parseInt(prodOne.slice(-2), 10);
            let prodTwoScore = parseInt(prodTwo.slice(-2), 10);
            return prodTwoScore - prodOneScore;
        });

        this.productRowIds = prodRowIdsSort;

    }

    replaceProductArray(update_isEstheticianPick,update_estheticianNodeValue) {
        const type = this.props.type;
        const userId = this.props.id;
        const urlOverride =  '/api/recommendation-overrides';
        const prodArr = this.productRowIds;

        if (this.state.prodIdInput === null || this.state.prodIdInput === undefined || this.state.prodIdInput == '' || this.state.prodIdInput.length == 0) {
            alert('No product ID specified.');
            return false;
        }

        const currentProdStr = this.state.currentRecoId.toString() + ":" + this.state.currentRecoScore.toString();
        const selectedInd = prodArr.indexOf(currentProdStr);
        

        const urlValid = '/api/is-valid-product?product-id=' + this.state.prodIdInput;
        fetch(urlValid, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                throw new Error("Reponse status error.");
            }
        })
        .then(responseJson => {
            if (!responseJson) {
                alert('There are no products with the ID: ' + this.state.prodIdInput);
                return;
            } else {
                if (this.state.expandedRecoId !== 0 || this.state.expandedRecoScore !== 0) {
                    const expandedRecoStr = this.state.expandedRecoId.toString() + ":" + this.state.expandedRecoScore.toString();
                    if (selectedInd >  -1) {
                        prodArr[selectedInd] = expandedRecoStr;
                    } 
                } else {
                    const prodIdInput = this.state.prodIdInput !== '' ? this.state.prodIdInput : this.state.currentRecoId.toString();
                    const inputRecoStr = prodIdInput + ":" + this.state.prodScoreInput;
                    if (selectedInd >  -1) {
                        prodArr[selectedInd] = inputRecoStr;
                    } 
                }

                prodArr.sort((prodOne, prodTwo) => {
                    let prodOneScore = parseInt(prodOne.slice(-2), 10);
                    let prodTwoScore = parseInt(prodTwo.slice(-2), 10);
                    return prodTwoScore - prodOneScore;
                });

                let prodArrOutput = prodArr.join();

                fetch(urlOverride, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth-token': Api.auth_tokenManager()
                    },
                    body: JSON.stringify({
                        'productIds': prodArrOutput,
                        'productType': type,
                        'userId': userId
                    })
                })
                .then(response => {
                    if (response.status === RESPONSE_STATUS.OK) {
                        this.setState({ 
                            selected: false
                        });
                        this.productRowIds = prodArr;

                        if(update_isEstheticianPick != undefined && update_isEstheticianPick != null){
                            this.fun_submitDataServer(this.state.prodIdInput,update_isEstheticianPick,update_estheticianNodeValue);
                        }else{
                            this.props.updateAfterChange();
                        }
                    } else {
                        throw new Error("Reponse status error.")
                    }
                })
                .catch(err => {
                    alert("There was a problem modifying the " + this.props.type + " product selections: " + err);
                });
            }
        })
        .catch(err => {
            alert("There was a problem checking if " + this.state.prodIdInput + " is a valid ID: " + err);
        });
    }

    fun_submitDataServer(productId,isEstheticianPick,estheticianNodeValue){
        const userId = this.props.id;
        HttpUtils.post("/api/portal-esthetician-picks",{
            userId: userId,
            productId: productId,
            note:estheticianNodeValue,
            isEstheticianPick:isEstheticianPick,
        }).then(()=>{
             this.props.updateAfterChange();
        })
    }

    addToProductArray(isEstheticianPick,estheticianNodeValue) {
        const type = this.props.type;
        const userId = this.props.id;
        const urlOverride =  '/api/recommendation-overrides';
        const prodArr = this.productRowIds;
        
        try {
            if (this.state.prodIdInput === null || this.state.prodIdInput === undefined) {
                alert('No product ID specified.');
                return false;
            }else if(!this.state.addInputId){
                alert('Product Id cannot be empty');
                return false
            }else if( prodArr.findIndex(age =>  age.split(":")[0] ==  this.state.addInputId )  != -1  ){
                alert('should not be able to add duplicated product');
                return false;
            }else if(this.state.prodIdInput.indexOf(" ") != -1 ||  this.state.addInputId.indexOf(" ") != -1 ){
                alert("not spaces");
                return false;
            }
    
            prodArr.push(this.state.addInputId + ":" + this.state.addInputScore);
            prodArr.sort((prodOne, prodTwo) => {
                let prodOneScore = parseInt(prodOne.slice(-2), 10);
                let prodTwoScore = parseInt(prodTwo.slice(-2), 10);
                return prodTwoScore - prodOneScore;
            });
            let prodArrOutput = prodArr.join();
    

    
    
            const urlValid = '/api/is-valid-product?product-id=' + this.state.addInputId;
            fetch(urlValid, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                }
            })
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw new Error("Reponse status error.");
                }
            })
            .then(responseJson => {
                if (!responseJson) {
                    alert('There are no products with the ID: ' + this.state.addInputId);
                    return;
                } else {
                    fetch(urlOverride, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'x-auth-token': Api.auth_tokenManager()
                        },
                        body: JSON.stringify({
                            'productIds': prodArrOutput,
                            'productType': type,
                            'userId': userId
                        })
                    })
                    .then(response => {
                        if (response.status === RESPONSE_STATUS.OK) {
                            this.productRowIds = prodArr;
                            if(isEstheticianPick != undefined && isEstheticianPick != null){
                                this.fun_submitDataServer(this.state.addInputId,isEstheticianPick,estheticianNodeValue);
                            }else{
                                this.props.updateAfterChange();
                            }
                        } else {
                            throw new Error("Reponse status error.")
                        }
                    })
                    .catch(err => {
                        alert("There was a problem adding a product to the recommended " + this.props.type + "s: " + err);
                    });
                }
            });
        } catch (error) {
            alert(error);
        }

        
        
    }

    removeProduct() {
        const type = this.props.type;
        const userId = this.props.id;
        const url =  '/api/recommendation-overrides';
        const prodArr = this.productRowIds;

        const currentProdStr = this.state.currentRecoId.toString() + ":" + this.state.currentRecoScore.toString();
        const selectedInd = prodArr.indexOf(currentProdStr);

        if (selectedInd > -1) {
            prodArr.splice(selectedInd, 1);
        } else if(selectedInd == -1) {
            alert("Product to remove not found in current recommendations");
            return;
        }

        prodArr.sort((prodOne, prodTwo) => {
            let prodOneScore = parseInt(prodOne.slice(-2), 10);
            let prodTwoScore = parseInt(prodTwo.slice(-2), 10);
            return prodTwoScore - prodOneScore;
        });


        let prodArrOutput = prodArr.join();

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                'productIds': prodArrOutput,
                'productType': type,
                'userId': userId
            })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ 
                    selected: false
                });
                this.productRowIds = prodArr;
                this.props.updateAfterChange();
            } else {
                throw new Error("Reponse status error.")
            }
        })
        .catch(err => {
            alert("There was a problem deleting the reocmmended" + this.props.type + " product: " + err);
        });
    }

    renderProductFeed() {
        let productRow = [];
        this.state.recommendedProducts.forEach((product, index, arr) => {
            // let lastOfType = (index === arr.length - 1 || (index !== arr.length - 1 && product.type !== arr[index + 1].type));
            if (product.type === this.props.type) {
                
                productRow.push(
                    <CustomerProduct
                        customerEmail={ this.props.customerEmail }
                        key={ "reco-" + index }
                        image={ product.coverImageSource }
                        price={ product.price } 
                        name={ product.name }
                        id={ product.id }
                        score={ product.score }
                        initialRecommendedProductId={ product.initialRecommendedProductId }
                        recReason={ product.recReason }
                        rowSelected={ this.state.isEditing }
                        updateAfterChange={ this.props.updateAfterChange }
                        getIdOfExpandedRecos={ this.getIdOfExpandedRecos.bind(this) }
                        getIdOfCurrentRecos={ this.getIdOfCurrentRecos.bind(this) }
                        currentRecoId={ this.state.currentRecoId }
                        currentRecoScore={ this.state.currentRecoScore }
                        expandedRecoId={ this.state.expandedRecoId }
                        expandedRecoScore={ this.state.expandedRecoScore }
                        additionalReco={ false }
                        type={ this.props.type }
                        userId={ this.props.id }
                        handleProductInputChange={ this.handleProductInputChange }
                        getScoreOfInputProduct={ this.getScoreOfInputProduct }
                        replaceProductArray={ this.replaceProductArray }
                        removeProduct={ this.removeProduct }
                        openDeleteModal={ this.onOpenDeleteModal }
                        estheticianPick={product.estheticianPick}
                        estheticianPickNote={product.estheticianPickNote}
                    />
                );
            }
        });

        if (productRow.length < 5) {     
                productRow.push(
                    <CustomerProductAdd
                        key={this.props.rowNumber}
                        rowNumber={this.props.rowNumber}
                        rowSelected={ this.state.isEditing }
                        handleAddProductInputChange={ this.handleAddProductInputChange }
                        handleAddProductInputChangeScore={ this.handleAddProductInputChangeScore }
                        addToProductArray={ this.addToProductArray }
                    />
                );   
        }
        return productRow;
    }

    getExpandedRecommendations() {
        // if (localStorage.getItem("user_id")) localStorage.removeItem("user_id");
        const userId = this.props.id;
        let currentRecos = [];
        this.state.recommendedProducts.forEach((product) => {
            if (product.type === this.props.type) {
                currentRecos.push(product.id);
            }
        });
        const currentRecosString = currentRecos.join();

        const url = '/api/expanded-recommendation?user-id=' + userId + '&product-type=' + this.props.type + '&excluded-product-ids=' + currentRecosString;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json())
        .then(responseJson => {
            // localStorage.setItem("user_id", responseJson.id);
            this.setState({ additionalRecos: responseJson });
        }).catch(function(err) {
            alert("There was a problem retrieving customer data: " + err);
        });
    }

    renderExpandedRecos() {
        let currentRecosRender = this.state.additionalRecos.map((product, index, arr) => {
            return(
                <CustomerProduct
                    key={ "expand-reco-" + index }
                    image={ product.coverImageSource }
                    price={ product.price } 
                    name={ product.name }
                    id={ product.id }
                    score={ product.score }
                    initialRecommendedProductId={ product.initialRecommendedProductId }
                    recReason={ product.recReason }
                    rowSelected={ this.state.isEditing }
                    updateAfterChange={ this.props.updateAfterChange }
                    additionalReco={ true }
                    getIdOfExpandedRecos={ this.getIdOfExpandedRecos.bind(this) }
                    getIdOfCurrentRecos={ this.getIdOfCurrentRecos.bind(this) }
                    currentRecoId={ this.state.currentRecoId }
                    currentRecoScore={ this.state.currentRecoScore }
                    expandedRecoId={ this.state.expandedRecoId }
                    expandedRecoScore={ this.state.expandedRecoScore }
                    type={ this.props.type }
                    userId={ this.props.id }
                />
            );
        });
        return currentRecosRender;
    }

    handleShowMore(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.state.showAdditionalRecos) {
            this.setState({ showAdditionalRecos: true, isEditing: true });
            this.getExpandedRecommendations();
        } else {
            this.setState({ showAdditionalRecos: false, isEditing: false });
        }
    }

    getIdOfCurrentRecos(id, score) {
        this.setState({ currentRecoId: id, currentRecoScore: score });
    }

    getIdOfExpandedRecos(id, score) {
        this.setState({ expandedRecoId: id, expandedRecoScore: score });
    }

    handleCancel() {
        this.setState({ showAdditionalRecos: false });
    }

    handleProductInputChange(input) {
        this.setState({ prodIdInput: input });
    }

    getScoreOfInputProduct(score) {
        this.setState({ prodScoreInput: score });
    }

    handleAddProductInputChange(input) {
        this.setState({ addInputId: input });
    }

    handleAddProductInputChangeScore(score) {
        this.setState({ addInputScore: score });
    }



    // handleReplace() {
    //     const email = this.props.customerEmail;
    //     const expandedId = parseInt(this.state.expandedRecoId, 10);
    //     const keyString = encodeURIComponent('_523GsudzE4Dj%Yv');
    //     const currentId = parseInt(this.state.currentRecoId, 10)
    //     const url = '/api/user-info?email=' + email + '&key=' + keyString + '&recommended-product-id=' + currentId + '&feedback-product-id=' + expandedId;
    //     fetch(url, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //             'x-auth-token': Api.auth_tokenManager()
    //         }
    //     })
    //     .then((response) => {
    //         response.json()
    //     })
    //     .then(responseJson => {
    //         this.setState({ 
    //             selected: false
    //         });
    //         this.props.updateAfterChange();
    //     })
    //     .catch(function(err) {
    //         alert("There was a problem overriding product recommendations: " + err);
    //     });
    
    // }

    onOpenDeleteModal = () => {
        this.setState({ showDeleteModal: true });
    };

    onCloseDeleteModal = () => {
        this.setState({ showDeleteModal: false });
    };


    render() {

        return (
            <div className={ !this.state.showAdditionalRecos ? "product-group" : "product-group expanded"}>
                <div className="product-group-type">{ this.props.type } { !this.state.isEditing ? <a href="#/" onClick={ this.toggleEditing } >edit</a> : <button onClick={ this.toggleEditing } >Save</button> }</div>
                <div className="product-group-row">
                    { this.renderProductFeed() }
                    <div className="show-more">
                        <button className={ !this.state.showAdditionalRecos ? "not-expanded" : "expanded" } onClick={ this.handleShowMore } >
                            { !this.state.showAdditionalRecos ? 
                            // <FaPlusCircle size={35} color="#9b9b9b" className="expand-product-button" />
                             <i className="fa fa-plus-circle" aria-hidden="true" style={{fontSize:'39px',color:'#9b9b9b'}}></i>
                             : null }
                        </button>
                    </div>
                </div>
                <div className={ !this.state.showAdditionalRecos ? "expanded-product-row hidden" : "expanded-product-row" }>
                    <div className="expanded-product-row-title">more products</div>
                    { this.state.showAdditionalRecos && this.state.additionalRecos.length > 0 ? this.renderExpandedRecos() : "No additional recommendations are available." }
                </div>
                <div className="expanded-product-row-buttons">
                   { 
                        (this.state.showAdditionalRecos && this.state.additionalRecos.length > 0) && 
                        (this.state.currentRecoId !== 0 && this.state.expandedRecoId !== 0) ? <button onClick={ this.replaceProductArray } >Replace</button> : null 
                    }
                    {
                        this.state.showAdditionalRecos ? <button className="cancel" onClick={ this.handleCancel } >Cancel</button> : null
                    }
                </div>
                <Modal open={ this.state.showDeleteModal } little onClose={ this.onCloseDeleteModal } classNames={{ overlay: 'ha-overlay', modal: 'ha-modal delete-product-modal' }}>
                    <div className="delete-product-modal">
                        <h3>Are you sure you want to delete this product?</h3>
                        <div className="yes-no">
                            <button className="no-delete" onClick={ this.onCloseDeleteModal }>No</button>
                            <button className="yes-delete" onClick={ this.removeProduct }>Yes</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default CustomerProductRow;



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/CustomerProductRow.js